import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser';
import './contact.css';


function Contact() {
    const form = useRef();
    const [phone, setPhone] = useState('');

    const handlePhoneChange = (e) => {
      let value = e.target.value.replace(/\D/g, ''); // Remove all non-digits
      
      // Format as: +92 XXX XXX XXXX or similar
      if (value.length > 0) {
        if (value.length <= 4) {
          // keep raw digits until there are enough numbers to format
        } else if (value.length <= 7) {
          value = value.slice(0, 3) + ' ' + value.slice(3);
        } else if (value.length <= 10) {
          value = value.slice(0, 3) + ' ' + value.slice(3, 6) + ' ' + value.slice(6);
        } else {
          value = value.slice(0, 2) + ' ' + value.slice(2, 5) + ' ' + value.slice(5, 8) + ' ' + value.slice(8, 11);
        }
      }
      setPhone(value);
    };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_ejoxvkh', 'template_f85atah', form.current, {
        publicKey: 'aExFZAhEcj6WfvGDr',
      })
      .then(
        () => {
        alert('Message submitted successfully!');
        form.current.reset(); 
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  return (
    <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
            Contact Us
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-center">
              <li className="breadcrumb-item">
                <a href="/">Home</a>
              </li>
              <li
                className="breadcrumb-item text-white active"
                aria-current="page"
              >
                Contact
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
      {/* Contact Start */}
      <div className="container-xxl py-5 contact-section">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          {/* <h6 className="section-title bg-white text-center text-primary px-3">
            Contact Us
          </h6> */}
          <h1 className="mb-5">Contact For Any Query</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="contact-card contact-info-card h-100">
              <h5 className="mb-4">Get In Touch</h5>
              <p className="mb-5">Contact us easily for inquiries, support, or travel assistance.</p>
              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <i className="fa fa-map-marker-alt" />
                </div>
                <div>
                  <h6 className="contact-info-title">Office</h6>
                  <p className="mb-0">Office # 813 8th Floor,<br />Park Avenue Building,<br />Sharah-e-Faisal Karachi, Pakistan</p>
                </div>
              </div>
              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <i className="fa fa-phone-alt" />
                </div>
                <div>
                  <h6 className="contact-info-title">Mobile</h6>
                  <p className="mb-0">+92 300 8261 571</p>
                </div>
              </div>
              <div className="contact-info-item mb-0">
                <div className="contact-info-icon">
                  <i className="fa fa-envelope-open" />
                </div>
                <div>
                  <h6 className="contact-info-title">Email</h6>
                  <p className="mb-0">sales@falcondestinations.com</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="contact-card h-100 overflow-hidden">
              <iframe
                className="contact-map w-100 h-100"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.387837381288!2d67.0748238150002!3d24.867838184050526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33fce18d019b3%3A0x4e7e67b1780f76a5!2sPark%20Avenue%20Building%2C%20Sharah-e-Faisal%2C%20Karachi%2C%20Pakistan!5e0!3m2!1sen!2sbd!4v1704630348170!5m2!1sen!2sbd"
                frameBorder={0}
                title="Falcon Destinations office location"
                allowFullScreen=""
                aria-hidden="false"
                tabIndex={0}
              />
            </div>
          </div>
          <div className="col-lg-4 col-md-12 wow fadeInUp" data-wow-delay="0.5s">
            <div className="contact-card contact-form h-100">
              <h5 className="mb-4">Send Us A Message</h5>
              <form ref={form} onSubmit={sendEmail}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Your Name"
                        name="name"
                      />
                      <label htmlFor="name">Your Name</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Your Email"
                        name="email"
                      />
                      <label htmlFor="email">Your Email</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="phone"
                        placeholder="Your Phone Number"
                        name="number"
                        value={phone}
                        onChange={handlePhoneChange}
                        maxLength="15"
                      />
                      <label htmlFor="phone">Phone Number</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Leave a message here"
                        id="message"
                        style={{ height: 140 }}
                        defaultValue={""}
                        name="message"
                      />
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="btn btn-primary w-100" type="submit" value="Send">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Contact End */}
    </div>
  )
}

export default Contact
